import { render, staticRenderFns } from "./Delegates.vue?vue&type=template&id=33e593c8&scoped=true"
import script from "./Delegates.vue?vue&type=script&lang=ts"
export * from "./Delegates.vue?vue&type=script&lang=ts"
import style0 from "./Delegates.vue?vue&type=style&index=0&id=33e593c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e593c8",
  null
  
)

export default component.exports